'use strict';

angular.module('theme').component('confirmGiftcard', {
	templateUrl: 'component/confirm-giftcard.html',
	bindings: {
		confirmgiftcard: '=',
		cont: '<',
		processing: '=',
	},
	controller: function($rootScope) {
		var self = this;

		this.$onInit = function() {
			self.confirmGiftcard = angular.copy(self.plan);
		};
	}
});
